import React, { useState } from 'react';
import { useAdminOrderStore } from 'src/hooks/admin/order';
import useReduxState from 'src/hooks/useReduxState';

const OrderAdminCommentPopup = ({ SetStatus }) => {
    const [{ }, { }, { update_admin_order_details }] = useAdminOrderStore();
    const [error, setError] = useState('');
    const [updateOrderDetail, setUpdateOrderDetail] = useReduxState({ poNumber: '', billingAddress: {}, shippingAddress: {}, comment: '', erpPartNumbers: [], orderNumber: '' }, "updateAdminOrderDetails");

    const handleCommentChange = (e) => {
        setUpdateOrderDetail({ ...updateOrderDetail, comment: e.target.value });
        if (error) setError('');
    };

    const validate = () => {
        const comment = updateOrderDetail.comment;
        if (!comment || comment.toString().trim() === '') {
            setError('This field is required');
            return false;
        }
        return true;
    };

    const handleSave = async () => {
        if (!validate()) return;
        const updateValueModify = {
            orderNumber: updateOrderDetail.orderNumber,
            erpPartNumbers: updateOrderDetail.erpPartNumbers,
            comment: updateOrderDetail.comment
        };

        if (updateOrderDetail.isBillingAddressEdited) {
            updateValueModify.billToAddress = updateOrderDetail.billingAddress;
        }

        if (updateOrderDetail.isShippingAddressEdited) {
            updateValueModify.shipToAddress = updateOrderDetail.shippingAddress;
        }

        if (updateOrderDetail.isPoNumberEdited) {
            updateValueModify.poNumber = updateOrderDetail.poNumber;
        }

        if (updateOrderDetail.isErpPartNumbersEdited) {
            updateValueModify.erpPartNumbers = updateOrderDetail.erpPartNumbers;
        }

        await update_admin_order_details(updateValueModify)
        window.location.reload();
        SetStatus(false);
    };
    return (
        <div className="avnet-modal modal-450">
            <div className="avnet-modal-inner">
                <button type="button" className="close" onClick={() => SetStatus(false)}>×</button>
                <div className="modal-header justify-content-center">
                    <h1 className="pcn-modal-heading">Add comment</h1>
                </div>
                <div className="modal-body">
                    <div className="form-group">
                        <textarea
                            placeholder="Enter Comment"
                            className={`avnet-textBox form-control form-control-sm ${error ? 'error' : ''}`}
                            value={updateOrderDetail.comment}
                            onChange={handleCommentChange}
                        />
                        {error && <p className="error">{error}</p>}
                    </div>
                </div>
                <div className="modal-footer d-flex justify-content-center">
                    <button type="button" className="bs5 btn btn-secondary minw140" onClick={() => SetStatus(false)}>Cancel</button>
                    <button type="button" className="bs5 btn btn-primary minw140" onClick={handleSave}>Save</button>
                </div>
            </div>
        </div>
    );
};

export default OrderAdminCommentPopup;
